export const config = {
	app: true,
	dark: true,
	temporary: true,
	width: '320px',
	class: 'pa-4',
	closeBtn: {
		icon: true
	},
	tabs: {
		dense: true,
		vertical: true,
		backgroundColor: 'transparent'
	},
	tab: {
		exact: true,
		class: 'justify-start mb-2'
	}
};
